import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';

import { formatNumber } from '../../Utilities/Helpers';
import { getCountyName } from '../../Utilities/Data';


export default function EventInfo({
  name,
  amount,
  fips,
  events,
  hazardOption,
  setEventNarratives
}) {
  const [eventName, setEventName] = useState(null);

  useEffect(() => {
    if (fips) {
      getCountyName(name).then(results => {
        setEventName(results);
      });
    } else {
      setEventName(name);
    }
  }, [name, amount]);


  const handleClick = (event) => {
    let localEvents;
    if (fips) {
      if (name === 'undefined') {
        localEvents = events.filter((eventItem) => eventItem.counties.length === 0);
      } else {
        localEvents = events.filter((eventItem) => eventItem.counties[0] === name);
      }
    } else {
      localEvents = events.filter((eventItem) => eventItem.event === event.target.textContent);
    }

    setEventNarratives(localEvents);
  };

  
  if (amount === 0 || amount === undefined) {
    return (
      (eventName === 'undefined' || amount === undefined) ? '' : <Typography onClick={handleClick}><span className="data-link">{eventName}</span></Typography>
    );
  } else {
    return (
      <Typography variant="body2"><span className="data-link" onClick={handleClick}>{eventName === 'undefined' ? 'State-wide' : eventName}</span>: {hazardOption.includes('damage') ? '$' : ''}{isNaN(amount) ? '-' : formatNumber(amount)}</Typography>
    );
  }
}

EventInfo.propTypes = {
  name: PropTypes.string,
  amount: PropTypes.number,
  fips: PropTypes.bool,
  events: PropTypes.array,
  hazardOption: PropTypes.string,
  setEventNarratives: PropTypes.func
};